import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, List, ListItem, ListItemText } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SubscriptionFAQ = () => {
    const navigate = useNavigate();

    const faqs = [
        {
            question: 'What is a subscription?',
            answer: 'A subscription allows you to access and manage features within Instapath for your organization. Subscriptions determine the number of users, pilots, and advanced tools available to you.',
        },
        {
            question: 'Who is the Pro plan designed for?',
            answer: 'The Pro plan is specifically designed for users of the Instapath Pilot app who have upgraded to Pilot Pro within the app. It offers enhanced features tailored for solo drone pilots, including advanced mission planning tools and integration with Instapath Cloud. This plan is ideal for pilots who need powerful tools to manage their operations but are not working as part of a larger team.',
        },
        {
            question: 'Why are Free and Pro plans limited to one pilot?',
            answer: 'The Free and Pro plans are designed for solo pilots or individuals not working as part of a team. These plans provide all the tools needed for mission planning and execution for a single pilot. To manage multiple pilots or collaborate with teams, you’ll need to upgrade to a Business or Enterprise plan, which includes advanced management features.',
        },
        {
            question: 'What happens if I want to add more pilots to a Free or Pro plan?',
            answer: 'If you need to manage multiple pilots, you’ll need to upgrade to a Business or greater plan. These plans allow you to add and manage multiple pilots, assign roles, and access team-oriented features like shared mission logs, analytics, and reporting.',
        },
        {
            question: 'How do I change the organization name?',
            answer: 'To change the organization name, click "Upgrade Plan" in the subscription menu. This will open a form where you can update the organization name, upgrade, or downgrade your subscription.',
        },
        {
            question: 'How do I cancel my subscription?',
            answer: 'You can cancel your subscription by selecting "Request to Cancel" from the subscription menu. This action will stop auto-renewal and disable features associated with the subscription at the end of the current billing period.',
        },
        {
            question: 'What happens to my data if my subscription expires or is canceled?',
            answer: 'Your data will be securely stored for 30 days after your subscription expires or is canceled. During this time, you can renew your subscription to regain access. After 30 days, your data may be permanently deleted.',
        },
        {
            question: 'Can I manage multiple subscriptions?',
            answer: 'Yes, you can manage multiple subscriptions for different organizations or projects. Each subscription operates independently, allowing you to configure settings and manage users uniquely for each organization.',
        },
        {
            question: 'Are there limits to the number of organizations I can create?',
            answer: 'No, there are no limits to the number of organizations you can create. However, each organization requires its own subscription.',
        },
        /*{
            question: 'What features are included in the Business and Enterprise plans?',
            answer: 'The Business and Enterprise plans include advanced features like multiple pilot management, team collaboration, detailed reporting, and priority support. Enterprise plans also offer custom integrations and enhanced analytics for large-scale operations.',
        },*/
        /*{
            question: 'Can I switch between plans?',
            answer: 'Yes, you can upgrade or downgrade your subscription at any time. If you switch plans mid-billing cycle, a pro-rated amount will be calculated based on your usage and the new plan’s rate.',
        },*/
        /*{
            question: 'Is there a discount for annual subscriptions?',
            answer: 'Yes, annual subscriptions typically offer a discount compared to month-to-month pricing. Check the subscription details for available discounts and promotions.',
        },*/
    ];

    return (
        <Box sx={{ padding: 2 }}>
            {/* Back Button */}
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
                <IconButton onClick={() => navigate(-1)} aria-label="back">
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h5" sx={{ marginLeft: 1, fontWeight: 500 }}>
                    Subscription FAQs
                </Typography>
            </Box>

            {/* FAQ List */}
            <List>
                {faqs.map((faq, index) => (
                    <ListItem key={index} sx={{ marginBottom: 2 }}>
                        <ListItemText
                            primary={
                                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                                    {faq.question}
                                </Typography>
                            }
                            secondary={
                                <Typography variant="body1" sx={{ color: '#6c757d' }}>
                                    {faq.answer}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default SubscriptionFAQ;